export * from './baMenu.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baMenu/index.ts